import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { getUserById } from "../models/UserFunctions.js";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import { Skeleton } from "@mui/material";
import TextField2 from "../textfields/TextField2.js";
import { useSnackbar } from "notistack";
import { useAppContext } from "../config/AppContext.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  last_of_list,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";
import DropDownGPT0 from "../dropdowns/DropDownGTP0.js";
import { DatePicker, Spin } from "antd";
import sendRTBatiment from "../api/send/sendRTBatiment.js";
import PdfEditor from "../sign/model/PdfEditor.js";
import DropDownGPT1 from "../dropdowns/DropDownGPT1.js";
import Modal1 from "../modals/Modal1.js";
import TimedProgressBar from "../loading/TimedProgressBar.js";
import sign from "../api/sign/sign.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import sendErrorDiscord from "../api/sendErrorDiscord.js";
import moment from "moment";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import Icon1 from "../icons/Icon.js";
import MLTFGPT1 from "../textfields/MLTFGPT1.js";
import CurrencyField from "../textfields/CurrencyField.js";
import SmallSpinner from "../loading/SmallSpinner.js";
import sendPennylaneGetAllClients from "../api/pennylane/sendPennylaneGetAllClients.js";
import sendPennylaneGetClient from "../api/pennylane/sendPennylaneGetClient.js";
import DropDownGPT0X from "../dropdowns/DropDownGTP0X.js";
import sendPennylaneCreateCompanyClient from "../api/pennylane/sendPennylaneCreateCompanyClient.js";
import sendPennylaneCreateDraftInvoice from "../api/pennylane/sendPennylaneCreateDraftInvoice.js";
import createDocApi from "../api/database/createDocApi.js";
import deleteDocApi from "../api/database/deleteDocApi.js";
import sendPennylaneGetAllProducts from "../api/pennylane/sendPennylaneGetAllProducts.js";
import sendPennylaneCreateProduct from "../api/pennylane/sendPennylaneCreateProduct.js";
import sendPennylaneGetAllLedgerAccounts from "../api/pennylane/sendPennylaneGetAllLedgerAccounts.js";
import sendPennylaneUpdateProduct from "../api/pennylane/sendPennylaneUpdateProduct.js";
import updateDocApi from "../api/database/updateDocApi.js";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3.js";
import { addActivityLog } from "../config/OnlineStatus.js";
import PDF from "../pdf/PDF.js";
import { EasySwitch } from "../textfields/EasySwitch.js";
import TextField2T from "../textfields/TextField2T.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import DatePickerGPT0 from "../textfields/DatePickerGPT0.js";
import dayjs from "dayjs";
import { formatToEuro } from "../pages/NewInvoiceDraft.js";
import sendPennylaneSaveInvoiceReglement from "../api/pennylane/sendPennylaneSaveInvoiceReglement.js";
import sendPennylaneCreateIndividualClient from "../api/pennylane/sendPennylaneCreateIndividualClient.js";
import sendPennylaneCreateQuote from "../api/pennylane/sendPennylaneCreateQuote.js";

function DevisPennylane({
  devisData,
  navigateWorkspace,
  forcePageReload,
  onClose,
  orgData,
  userData,
}) {
  const [clientData, setClientData] = useState(null);
  const [workspace, setWorkspace] = useState(null);
  const [pennylane_clients, setPennylaneClients] = useState([]);
  const [pennylane_products, setPennylaneProducts] = useState([]);
  const [pennylane_ledger_accounts, setPennylaneLedgerAccounts] = useState([]);
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [step, setStep] = useState(0);
  const [quoteData, setQuoteData] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [no_pennylane_id_open, setNoPennylaneIdOpen] = useState(false);
  const [all_articles, setAllArticles] = useState([]);
  const [pennylane_selected_client, setPennylaneSelectedClient] =
    useState(null);
  const [pennylane_override, setPennylaneOverride] = useState(false);
  const [articles_options, setArticlesOptions] = useState([]);
  const [addOnOpen, setAddOnOpen] = useState(false);
  const [addOnValue, setAddOnValue] = useState(null);
  const [slots_items, setSlotsItems] = useState([]);
  const [useParticulier, setUseParticulier] = useState(false);
  const [selected_slot, setSelectedSlot] = useState(null);
  const [payment_conditions, setPaymentConditions] = useState([
    {
      value: "upon_receipt",
      label: "À réception",
    },
    {
      value: "custom",
      label: "Personnalisé",
    },
    {
      value: "15_days",
      label: "15 jours",
    },
    {
      value: "30_days",
      label: "30 jours",
    },
    {
      value: "45_days",
      label: "45 jours",
    },
    {
      value: "60_days",
      label: "60 jours",
    },
  ]);
  const [created_devis_url, setCreatedDevisUrl] = useState(null);
  const [created_devis, setCreatedDevis] = useState(null);
  const [selected_articles, setSelectedArticles] = useState([
    {
      id: null,
      default: null,
      price: 0,
      quantity: 1,
      discount: null,
      tax: { value: 20, label: "20%", pennylane_value: "FR_200" },
      total: 0,
    },
  ]);
  const [loadinFetch, setLoadingFetch] = useState(true);

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (orgData) {
      try {
        let client;
        let first_admin;
        if (devisData.client_type !== "particulier") {
          client = await getOrgById(devisData.client_id);
          setClientData(client);
          let workspaces = await getArrayDocDataByID(
            "workspace",
            client.workspaces_id || []
          );
          let workspace = workspaces.find((w) => w.master_id === orgData.id);
          setWorkspace(workspace);

          const client_users = await getArrayDocDataByID(
            "user",
            client.users_id
          );
          const admin_users = client_users.filter((u) => u.org_admin);
          let first_admin = last_of_list(admin_users);

          if (
            admin_users.length === 0 &&
            devisData.client_type !== "particulier"
          ) {
            handleClickVariant(
              "Aucun utilisateur administrateur trouvé pour ce client",
              "error"
            );
            return;
          }
        }

        const articles_filters = [
          {
            field: "org_id",
            operator: "==",
            value: orgData.id,
          },
        ];
        let articles = await queryCollection("article", articles_filters);

        await handleGetPennylaneProducts();
        // await handleGetPennylaneLegderAccounts();

        setAllArticles(articles);
        setArticlesOptions(
          articles.map((a) => {
            return { value: a.id, label: a.name };
          })
        );

        // we need to add the articles that were in the devis
        let articles_to_select_default = [];
        devisData.articles.forEach((devis_article) => {
          let matching_article = articles.find(
            (a) => a?.id === devis_article?.id
          );
          console.log("matching_article", matching_article);
          if (matching_article) {
            let price = getNegocePrice(matching_article);
            console.log("price", price);
            articles_to_select_default.push({
              id: matching_article.id,
              default: matching_article.id,
              price: parseFloat(price.price_ht_rounded),
              quantity: devis_article.quantity,
              discount: devis_article.discount || null,
              tax: matching_article.tax || {
                value: 20,
                label: "20%",
                pennylane_value: "FR_200",
              },
              total:
                parseFloat(price.price_ht_rounded) * devis_article.quantity,
            });
          }
        });
        setSelectedArticles(articles_to_select_default);

        // setSlotsItems(slots);
        await handleGetPennylaneClients();
        let client_dict = {};
        if (devisData.client_type !== "particulier") {
          if (!client.pennylane?.client_id) {
            if (pennylane_clients.length === 0) {
              setNoPennylaneIdOpen(true);
            }

            client_dict = {
              client_company: true,
              client_name: devisData.marque,
              client_recipient: first_admin?.display_name || devisData.nom,
              client_email: client.email,
              client_phone: client.phone,
              client_reference: "",
              client_address: client.infos.adresse,
              client_postal: client.infos.postal,
              client_city: client.infos.ville,
              payment_conditions: client.pennylane?.payment_conditions || null,
            };
          } else if (client.pennylane?.client_id) {
            const client_id = client.pennylane?.client_id;
            const pennylane_client = await handleGetPennylaneClient(client_id);
            if (pennylane_client) {
              client_dict = {
                client_company: devisData.partner_type !== "particulier",
                client_name: pennylane_client.name,
                client_recipient: pennylane_client.recipient,
                client_email: pennylane_client.emails[0],
                client_phone: pennylane_client.phone,
                client_reference: pennylane_client.reference,
                client_address: pennylane_client.billing_address.address,
                client_postal: pennylane_client.billing_address.postal_code,
                client_city: pennylane_client.billing_address.city,
                payment_conditions: pennylane_client.payment_conditions || null,
              };
              setPennylaneSelectedClient(pennylane_client);
              setPennylaneOverride(true);
            } else {
              client_dict = {
                client_company: devisData.partner_type !== "particulier",
                client_name: devisData.marque,
                client_recipient: first_admin.display_name,
                client_email: client.email,
                client_phone: client.phone,
                client_reference: "",
                client_address: client.infos.adresse,
                client_postal: client.infos.postal,
                client_city: client.infos.ville,
                payment_conditions:
                  client.pennylane?.payment_conditions || null,
              };
            }
          }
        } else {
          if (devisData.pennylane?.client_id) {
            const client_id = devisData.pennylane?.client_id;
            const pennylane_client = await handleGetPennylaneClient(client_id);
            if (pennylane_client) {
              client_dict = {
                client_company: false,
                client_first_name: pennylane_client.first_name,
                client_last_name: pennylane_client.last_name,
                client_recipient: pennylane_client.recipient,
                client_email: pennylane_client.emails[0],
                client_phone: pennylane_client.phone,
                client_reference: pennylane_client.reference,
                client_address: pennylane_client.billing_address.address,
                client_postal: pennylane_client.billing_address.postal_code,
                client_city: pennylane_client.billing_address.city,
                payment_conditions:
                  pennylane_client?.payment_conditions || null,
              };
              setPennylaneSelectedClient(pennylane_client);
              setPennylaneOverride(true);
            } else {
              client_dict = {
                client_company: false,
                client_first_name: devisData.first_name || "",
                client_last_name: devisData.nom,
                client_recipient:
                  (devisData.first_name || "") + " " + devisData.nom,
                client_email: devisData.email_client,
                client_phone: devisData.tel_client,
                client_reference: "",
                client_address: devisData.adresse_client,
                client_postal: devisData.postal_client,
                client_city: devisData.ville_client,
                payment_conditions: "30_days",
              };
            }
          } else {
            client_dict = {
              client_company: false,
              client_first_name: devisData.first_name || "",
              client_last_name: devisData.nom,
              client_recipient:
                (devisData.first_name || "") + " " + devisData.nom,
              client_email: devisData.email_client,
              client_phone: devisData.tel_client,
              client_reference: "",
              client_address: devisData.adresse_client,
              client_postal: devisData.postal_client,
              client_city: devisData.ville_client,
              payment_conditions: "30_days",
            };
          }
        }
        console.log("CLIENT DICT", client_dict);
        console.log("devisData.reglement", devisData.reglement);

        let emission_date = getFlutterTime();
        let deadline_days =
          client_dict.payment_conditions === "15_days"
            ? 15
            : client_dict.payment_conditions === "30_days"
              ? 30
              : client_dict.payment_conditions === "45_days"
                ? 45
                : client_dict.payment_conditions === "60_days"
                  ? 60
                  : 30;
        let deadline_date = getFlutterTimeFromSeconds(
          emission_date.seconds + deadline_days * 24 * 60 * 60
        );

        let devis_dict = {
          devis_title: "Devis " + devisData.nom,
          devis_type: "Prestation de services",
          devis_date: emission_date,
          devis_deadline: deadline_date,
        };
        let dict = { ...client_dict, ...devis_dict };
        setUseParticulier(
          devisData.client_type === "particulier" ? true : false
        );

        setQuoteData(dict);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setLoadingFetch(false);
    }
  };

  const [prestation_initialised, setInitialised] = useState(false);

  // useEffect(() => {
  //   if (all_articles && !prestation_initialised) {
  //     let pack_ref = devisData.pack_ref || null;
  //     let mathing_article = all_articles.find(
  //       (a) => a.pack_ref?.id === pack_ref?.id
  //     );

  //     if (mathing_article) {
  //       let new_articles = [...selected_articles];
  //       new_articles[0].default = mathing_article.id;

  //       setSelectedArticles(new_articles);
  //       handleSetNegocePrice(mathing_article.id, 0);
  //       setInitialised(true);
  //     }
  //   }
  // }, [all_articles]);

  const handleGetPennylaneClient = async (client_id) => {
    if (!client_id) {
      handleClickVariant("Aucun client sélectionné", "error");
      return null;
    }
    const token = await getOrRefreshFirebaseToken();
    const res = await sendPennylaneGetClient(client_id, token, prefix);
    if (res.success === false) {
      if (res.status_code === 404) {
        // client has been deleted on Pennylane

        handleClickVariant("Le client Pennylane n'a pas été récupéré", "error");
        return null;
      } else {
        handleClickVariant(
          "Vous devez reconnecter votre compte Pennylane",
          "error"
        );
        navigateWorkspace("/pennylane");
        return;
      }
    } else {
      const client = res.client;
      setPennylaneSelectedClient(client);
      return client;
    }
  };

  const handleGetPennylaneClients = async (search_value = "") => {
    const token = await getOrRefreshFirebaseToken();
    const res = await sendPennylaneGetAllClients(search_value, token, prefix);
    if (res.success === false) {
      handleClickVariant(
        "Vous devez reconnecter votre compte Pennylane",
        "error"
      );
      navigateWorkspace("/pennylane");
      return;
    } else {
      const clients = res.clients;
      setPennylaneClients(clients?.items || []);
    }
  };

  const handleGetPennylaneProducts = async (cursor = null) => {
    const token = await getOrRefreshFirebaseToken();
    const res = await sendPennylaneGetAllProducts(cursor, token, prefix);
    if (res.success === false) {
      handleClickVariant(
        "Vous devez reconnecter votre compte Pennylane",
        "error"
      );
      navigateWorkspace("/pennylane");
      return;
    } else {
      const products = res.products;
      setPennylaneProducts(products.items || []);
    }
  };

  const handleGetPennylaneLegderAccounts = async () => {
    const token = await getOrRefreshFirebaseToken();
    const res = await sendPennylaneGetAllLedgerAccounts(token, prefix);
    if (res.success === false) {
      handleClickVariant(
        "Vous devez reconnecter votre compte Pennylane",
        "error"
      );
      navigateWorkspace("/pennylane");
      return;
    } else {
      const ledger_accounts = res.ledger_accounts;
      setPennylaneLedgerAccounts(ledger_accounts.items || []);
    }
  };

  const handleGoArticle = () => {
    navigateWorkspace("/products");
  };

  const handleAddArticle = () => {
    let new_articles = [...selected_articles];
    new_articles.push({
      default: null,
      price: 0,
      quantity: 1,
      discount: null,
      tax: { value: 20, label: "20%", pennylane_value: "FR_200" },
      total: 0,
    });
    setSelectedArticles(new_articles);
  };

  const [loadingClient, setLoadingClient] = useState(false);

  function getNegocePrice(article) {
    if (!workspace) {
      // this is a particulier, use default price
      const bp = parseFloat(article.base_price) || 0;
      return {
        price_ht_rounded: bp.toFixed(2),
        price_ttc_rounded: (bp * 1.2).toFixed(2),
      };
    }
    const negoces = workspace.negoces || [];
    const negoce = negoces.find(
      (neg) =>
        neg.article_id === article?.id && neg.client_id === clientData?.id
    );

    const price_ht = negoce ? parseFloat(negoce.price_ht) : article.base_price;
    const price_ttc = negoce
      ? parseFloat(negoce.price_ht) * 1.2
      : article.base_price * 1.2;

    // Round it to 2 decimal places
    const price_ht_rounded = price_ht?.toFixed(2);
    const price_ttc_rounded = price_ttc?.toFixed(2);

    return {
      price_ht_rounded: isNaN(price_ht_rounded) ? 0 : price_ht_rounded,
      price_ttc_rounded: isNaN(price_ttc_rounded) ? 0 : price_ttc_rounded,
    };
  }

  function getTotals() {
    let base_ht = 0;
    let supplement = addOnValue?.value || 0;
    let total_remise = 0;
    let total_ht = 0;
    let tva = 0;
    let total_ttc = 0;

    selected_articles.forEach((a) => {
      base_ht += a.price * a.quantity;
      total_remise += a.discount
        ? a.discount.type === "relative"
          ? (a.discount.value / 100) * a.price * a.quantity
          : a.discount.value
        : 0;
      total_ht += a.price * a.quantity;
      tva += (a.price - total_remise) * a.quantity * (a.tax.value / 100);
    });
    total_ht += supplement - total_remise;
    tva += supplement * 0.2;
    total_ttc = total_ht + tva;

    return {
      base_ht: base_ht,
      supplement: supplement,
      total_remise: total_remise,
      total_ht: total_ht,
      tva: tva,
      total_ttc: total_ttc,
    };
  }
  const [loadingSearch, setLoadingSearch] = useState(false);
  const handleSearchPennylaneClientsSearch = async (value) => {
    setLoadingSearch(true);
    await handleGetPennylaneClients(value);
    setLoadingSearch(false);
  };

  const handleUsePennylaneClient = async (value) => {
    // query clients on Pennylane with filter value
    setLoadingClient(true);
    await updateDocDataFieldApi(
      clientData.ref,
      "pennylane.client_id",
      value,
      prefix
    );
    await handleFetchData();
    setNoPennylaneIdOpen(false);

    setLoadingClient(false);
  };

  const handleSetNegocePrice = (article_id, index) => {
    let negoce_prices = getNegocePrice(
      all_articles.find((a) => a.id === article_id)
    );
    let article = all_articles.find((a) => a.id === article_id);
    setSelectedArticles((prev) => {
      let new_articles = [...prev];
      new_articles[index].conditions_reglement = article.conditions_reglement;
      new_articles[index].id = article.id;
      new_articles[index].price = negoce_prices.price_ht_rounded;
      new_articles[index].total =
        new_articles[index].price *
        new_articles[index].quantity *
        (1 + new_articles[index].tax.value / 100);
      return new_articles;
    });
  };

  const [loadingData, setLoadingData] = useState(false);

  const goClientPage = () => {
    navigateWorkspace("/partner/" + clientData.id);
  };

  const handleChangeClient = async () => {
    if (pennylane_clients.length === 0) {
      // await handleGetPennylaneClients();
    }
    setNoPennylaneIdOpen(true);
  };

  const handleSkipLinkingPennylane = async () => {
    setLoadingClient(true);
    await updateDocDataFieldApi(
      clientData.ref,
      "pennylane.client_id",
      null,
      prefix
    );
    setClientData({ ...clientData, pennylane: { client_id: null } });

    setNoPennylaneIdOpen(false);
    setPennylaneSelectedClient(null);
    setPennylaneOverride(false);
    await handleFetchData();

    setLoadingClient(false);
  };

  const handleSendDevis = async () => {
    setLoadingData(true);
    try {
      let client_id = clientData?.pennylane?.client_id || null;
      const token = await getOrRefreshFirebaseToken();
      if (!quoteData.payment_conditions) {
        handleClickVariant(
          "Veuillez sélectionner une condition de paiement",
          "error"
        );
        setLoadingData(false);
        return;
      }

      if (useParticulier && devisData.pennylane?.client_id) {
        client_id = devisData.pennylane.client_id;
      }
      let client_pennylane = null;
      if (client_id) {
        client_pennylane = await handleGetPennylaneClient(client_id);
      }

      if (
        (!useParticulier && !clientData?.pennylane?.client_id) ||
        (useParticulier && !devisData.pennylane?.client_id) ||
        !client_pennylane
      ) {
        let client_res = null;

        if (!useParticulier) {
          let client_payload = {
            name: quoteData.client_name,
            billing_iban: "",
            payment_conditions: quoteData.payment_conditions,
            recipient: quoteData.client_recipient,
            phone: quoteData.client_phone,
            reference: quoteData.client_reference,
            notes: "",
            vat_number: "",
            reg_no: "",
            ledger_account: null,
            emails: [quoteData.client_email],
            billing_address: {
              address: quoteData.client_address,
              postal_code: quoteData.client_postal,
              city: quoteData.client_city,
              country_alpha2: "FR",
            },
            delivery_address: {
              address: quoteData.client_address,
              postal_code: quoteData.client_postal,
              city: quoteData.client_city,
              country_alpha2: "FR",
            },
            external_reference: clientData?.id,
          };
          let client_full_payload = {
            client: client_payload,

            client_type: devisData.client_type,
            folder_id: devisData.id,
          };
          client_res = await sendPennylaneCreateCompanyClient(
            client_full_payload,
            token,
            prefix
          );
        } else {
          let client_payload = {
            first_name: quoteData.client_first_name,
            last_name: quoteData.client_last_name,
            billing_iban: "",
            payment_conditions: quoteData.payment_conditions,
            recipient: quoteData.client_recipient,
            phone: quoteData.client_phone,
            reference: quoteData.client_reference,
            notes: "",
            ledger_account: null,
            emails: [quoteData.client_email],
            billing_address: {
              address: quoteData.client_address,
              postal_code: quoteData.client_postal,
              city: quoteData.client_city,
              country_alpha2: "FR",
            },
            delivery_address: {
              address: quoteData.client_address,
              postal_code: quoteData.client_postal,
              city: quoteData.client_city,
              country_alpha2: "FR",
            },
            external_reference: devisData.id,
          };
          let client_full_payload = {
            client: client_payload,

            client_type: devisData.client_type,
            folder_id: devisData.id,
          };
          client_res = await sendPennylaneCreateIndividualClient(
            client_full_payload,
            token,
            prefix
          );
        }
        if (client_res.success) {
          client_id = client_res.client.id;
          await updateDocApi(
            devisData.ref,
            {
              pennylane: {
                client_id: client_id,
              },
            },
            prefix
          );
        } else {
          handleClickVariant(
            "Erreur lors de la création du client Pennylane",
            "error"
          );
          setLoadingData(false);
          return;
        }
      }

      let invoice_lines = [];

      for (let selected_article of selected_articles) {
        if (!selected_article.id) {
          console.log("selected_articles", selected_articles);
          handleClickVariant("Veuillez sélectionner un article", "error");
          return;
        }
        let article = all_articles.find(
          (art) => art.id === selected_article.id
        );
        let pennylane_article_id = article.pennylane?.article_id;
        if (
          !pennylane_article_id ||
          pennylane_products.map((p) => p.id).includes(pennylane_article_id) ===
            false ||
          article.pennylane?.needs_sync
        ) {
          let product_dict = {
            label: article.name,
            description: article.description,
            external_reference: article.id,
            price_before_tax: selected_article.price.toString(),
            vat_rate: selected_article.tax.pennylane_value,
            unit: "piece",
            currency: "EUR",
            reference: article.id,
            ledger_account_id: null,
          };

          let product_payload = {
            product: product_dict,
            article_id: article.id,
          };

          let new_product = null;

          if (article.pennylane?.needs_sync && article.pennylane?.article_id) {
            new_product = await sendPennylaneUpdateProduct(
              article.pennylane?.article_id,
              product_payload,
              token,
              prefix
            );
          } else {
            new_product = await sendPennylaneCreateProduct(
              product_payload,
              token,
              prefix
            );

            if (new_product.success) {
              pennylane_article_id = new_product.product.id;
              article.pennylane = { article_id: pennylane_article_id };
              setAllArticles((prev) => {
                let new_articles = [...prev];
                let index = new_articles.findIndex((a) => a.id === article.id);
                new_articles[index] = article;
                return new_articles;
              });
            } else {
              handleClickVariant(
                "Erreur lors de la création de l'article Pennylane",
                "error"
              );
              setLoadingData(false);
              return;
            }
          }
        }

        invoice_lines.push({
          quantity: selected_article.quantity,
          label: article.name,
          section_rank: all_articles.findIndex(
            (art) => art.id === selected_article.id
          ),
          discount: selected_article.discount?.value
            ? {
                type: selected_article.discount
                  ? selected_article.discount?.type === "amount"
                    ? "absolute"
                    : "relative"
                  : "absolute",

                value: selected_article.discount
                  ? selected_article.discount?.value?.toString()
                  : "0",
              }
            : null,
          raw_currency_unit_price: selected_article.price.toString(),
          unit: "piece",
          vat_rate: selected_article.tax.pennylane_value,
          description: article.description,
          product_id: pennylane_article_id,
          ledger_account_id: 1255,
        });
      }

      // ISO 8601 date format

      let devis_payload = {
        date: dayjs.unix(quoteData.devis_date.seconds).format("YYYY-MM-DD"),
        deadline: dayjs
          .unix(quoteData.devis_deadline.seconds)
          .format("YYYY-MM-DD"),
        customer_id: client_id,
        customer_invoice_template_id: null,
        pdf_invoice_free_text: quoteData.devis_free_field,
        pdf_invoice_subject: quoteData.devis_title,
        pdf_description: quoteData.devis_description,
        currency: "EUR",
        special_mention: quoteData.devis_special_mention,
        language: "fr_FR",
        discount: {
          type: "absolute",
          value: "0",
        },
        creation_time: getFlutterTime(),
        invoice_line_sections: [],
        invoice_lines: invoice_lines,
        external_reference: null,
        master_id: orgData.id,
        devis_id: devisData.id,
        hexagone_status: "hexagone_draft",
      };

      let new_pennylane_devis = await createDocApi(
        "pennylane_devis",
        devis_payload,
        prefix
      );

      devis_payload.external_reference = new_pennylane_devis.id;

      let res = await sendPennylaneCreateQuote(
        devis_payload,
        devisData.id,

        token,
        prefix
      );

      if (!res.success) {
        handleClickVariant("Erreur lors de la création de la devis", "error");
        await deleteDocApi(new_pennylane_devis.ref, prefix);
        setLoadingData(false);
        return;
      } else {
        handleClickVariant("Devis générée avec succès", "success");
        await updateDocApi(
          new_pennylane_devis.ref,
          {
            pennylane_devis_id: res.quote.id,
            pennylane_devis_url: res.quote.public_file_url,
            status: "wait",
          },
          prefix
        );

        new_pennylane_devis.pennylane_devis_id = res.quote.id;
        new_pennylane_devis.pennylane_devis_url = res.quote.public_file_url;
        new_pennylane_devis.status = "wait";

        window.open(res.quote.public_file_url, "_blank");
        // display devis

        let history_events = devisData.history_events || [];
        history_events.push({
          name: "Devis Pennylane créé",
          date: getFlutterTime(),
        });

        await updateDocApi(
          devisData.ref,
          {
            pennylane: {
              devis_id: new_pennylane_devis.id,
              history_events: history_events,
            },
          },
          prefix
        );

        // close
        onClose();
        handleClickVariant(
          "Vous pouvez retrouver votre devis dans Pennylane.",
          "info"
        );
      }
    } catch (error) {
      console.error("Error sending devis:", error);
      handleClickVariant("Erreur lors de l'envoi de la devis", "error");
    }
    setLoadingData(false);
  };

  useEffect(() => {
    if (orgData) {
      handleFetchData();
    }
  }, [orgData]);

  if (!orgData || !userData || loadinFetch) {
    return (
      <div className="bg-white p-4 rounded-xl">
        <SmallSpinner></SmallSpinner>
      </div>
    );
  }

  return (
    <div className="w-full h-full  max-w-c1p2k flex flex-row items-center justify-center p-10">
      <Modal1
        isOpen={no_pennylane_id_open}
        onClose={() => setNoPennylaneIdOpen(false)}
      >
        {clientData?.pennylane?.client_id ? (
          <div className="flex flex-col gap-2 p-4 bg-white rounded-xl max-w-c500">
            <div className="text-h1 font-semibold">
              Ce client{" "}
              <span className="text-indigo-500 font-semibold ">hexagone</span>{" "}
              est lié à un client{" "}
              <span className="text-green-600 font-semibold ">Pennylane</span>
            </div>
            <div className="text-h2 text-shadow_50  mt-4">
              <span className="text-black">Option 1 : </span>Déconnecter du
              client{" "}
              <span className="text-green-600 font-semibold ">Pennylane</span>
            </div>{" "}
            <SecondaryButton
              className={"w-fit"}
              onClick={handleSkipLinkingPennylane}
            >
              Déconnecter du client Pennylane
            </SecondaryButton>
            <SecondaryButton
              className={"w-fit"}
              onClick={() => {
                setPennylaneOverride(false);
                setUseParticulier(true);
                setQuoteData({
                  ...quoteData,
                  client_name: devisData.nom,
                  client_recipient: devisData.nom,
                  client_email: devisData.reglement?.infos.email,
                  client_phone: devisData.reglement?.infos.phone,
                });
                setPennylaneSelectedClient(null);
                setNoPennylaneIdOpen(false);
                setLoadingClient(false);
              }}
            >
              Utiliser le particulier du devis
            </SecondaryButton>
            <div className="text-h2 text-shadow_50 mt-4">
              <span className="text-black">Option 2 : </span>Relier le client{" "}
              <span className="text-indigo-500 font-semibold ">hexagone</span> à
              un autre client{" "}
              <span className="text-green-600 font-semibold ">Pennylane</span>{" "}
              existant
            </div>
            <div className="text-h3 text-shadow_50">
              Veuillez sélectionner un identifiant Pennylane pour ce client
            </div>
            <DropDownGPTS3
              items={pennylane_clients.map((c) => {
                return { value: c.id, label: c.name };
              })}
              onSearchChange={(value) =>
                handleSearchPennylaneClientsSearch(value)
              }
              loadingSearch={loadingSearch}
              value={null}
              onChange={(e) => handleUsePennylaneClient(e.value)}
              label={"Recherchez un client Pennylane"}
            ></DropDownGPTS3>
            <div className="flex flex-row justify-end gap-2">
              <SecondaryButton
                className={"w-fit"}
                onClick={() => {
                  onClose();
                }}
              >
                Quitter la création de devis
              </SecondaryButton>{" "}
            </div>
            <div className="flex flex-row justify-center ">
              <SmallSpinner loading={loadingClient} />
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-2 p-4 bg-white rounded-xl max-w-c500">
            <div className="text-h1 font-semibold">
              Ce client{" "}
              <span className="text-indigo-500 font-semibold ">hexagone</span>{" "}
              n'est pas lié à un client{" "}
              <span className="text-green-600 font-semibold ">Pennylane</span>
            </div>
            <div className="text-h2 text-shadow_50  mt-4">
              <span className="text-black">Option 1 : </span>Créer un nouveau
              client dans{" "}
              <span className="text-green-600 font-semibold ">Pennylane</span> à
              partir du client{" "}
              <span className="text-indigo-500 font-semibold ">hexagone</span>
            </div>{" "}
            <SecondaryButton
              className={"w-fit"}
              onClick={handleSkipLinkingPennylane}
            >
              Créer un nouveau client
            </SecondaryButton>
            <SecondaryButton
              className={"w-fit"}
              onClick={() => {
                setPennylaneOverride(false);
                setUseParticulier(true);
                setQuoteData({
                  ...quoteData,
                  client_name: devisData.nom,
                  client_recipient: devisData.nom,
                  client_email: devisData.reglement?.infos?.email,
                  client_phone: devisData.reglement?.infos?.phone,
                });
                setPennylaneSelectedClient(null);
                setNoPennylaneIdOpen(false);
                setLoadingClient(false);
              }}
            >
              Utiliser le particulier du dossier
            </SecondaryButton>
            <div className="text-h2 text-shadow_50 mt-4">
              <span className="text-black">Option 2 : </span>Relier le client{" "}
              <span className="text-indigo-500 font-semibold ">hexagone</span> à
              un client{" "}
              <span className="text-green-600 font-semibold ">Pennylane</span>{" "}
              existant
            </div>
            <div className="text-h3 text-shadow_50">
              Veuillez sélectionner un identifiant Pennylane pour ce client
            </div>
            <DropDownGPTS3
              items={pennylane_clients.map((c) => {
                return { value: c.id, label: c.name };
              })}
              onSearchChange={(value) =>
                handleSearchPennylaneClientsSearch(value)
              }
              loadingSearch={loadingSearch}
              value={null}
              onChange={(e) => handleUsePennylaneClient(e.value)}
              label={"Sélectionnez un client Pennylane"}
            ></DropDownGPTS3>
            <div className="flex flex-row justify-end gap-2">
              <SecondaryButton
                className={"w-fit"}
                onClick={() => {
                  onClose();
                }}
              >
                Quitter la création de devis
              </SecondaryButton>
            </div>{" "}
            <div className="flex flex-row justify-center ">
              <SmallSpinner loading={loadingClient} />
            </div>
          </div>
        )}
      </Modal1>

      <div className="flex flex-col w-full  rounded-xl h-full   bg-white p-4 ">
        <div className="flex flex-col  overflow-y-auto h-full w-full pb-10">
          <div className="flex flex-row justify-between  w-full">
            <div className="text-h1 text-black font-medium flex flex-row items-center gap-1">
              Nouveau devis{" "}
              <span className="text-green-600 font-semibold">Pennylane</span>
              <Icon1 icon_name="pennylane" fill="#16a34a" size={20} />
            </div>
            <div className="flex flex-row gap-2">
              {quoteData.client_company && (
                <SecondaryButton onClick={goClientPage}>
                  Modifier les tarifs négociés avec ce client
                </SecondaryButton>
              )}

              <SecondaryButton onClick={onClose}>Fermer</SecondaryButton>
            </div>
          </div>
          <div className="text-h3 text-shadow_50 mt-1">
            Remplissez les informations de la devis Pennylane
          </div>

          <div className="flex flex-row justify-between gap-10 mx-2">
            <div className="flex flex-col w-c400">
              <div className="text-h3 text-shadow_50 mt-10 font-semibold gap-1 flex flex-row items-center">
                <span> Informations client </span>

                {pennylane_override ? (
                  <span className="font-semibold text-green-600">
                    Pennylane
                  </span>
                ) : (
                  <span className="font-semibold text-indigo-500">
                    hexagone
                  </span>
                )}
                {devisData?.client_type !== "particulier" && (
                  <SecondaryButton
                    onClick={handleChangeClient}
                    className={"w-fit"}
                  >
                    Changer
                  </SecondaryButton>
                )}
              </div>
              <div className="flex flex-row text-h3 text-shadow_50 items-center gap-1 max-w-c400 mt-3 ml-2">
                <EasySwitch
                  checked={useParticulier}
                  onChange={(checked) => {
                    setUseParticulier(checked);
                    if (checked) {
                      setQuoteData({
                        ...quoteData,
                        cliennt_first_name: devisData.first_name || "",
                        client_last_name: devisData.nom,
                        client_recipient: devisData.nom,
                        client_email: devisData.email_client,
                        client_phone: devisData.tel_client,
                      });
                    } else {
                      handleFetchData();
                    }
                  }}
                ></EasySwitch>{" "}
                Utiliser le particulier du dossier
              </div>
              <div className="flex flex-col gap-1  mt-3 ml-2">
                <TextField2T
                  label={"Type de client"}
                  disabled={true}
                  value={
                    quoteData.client_company
                      ? "Client Entreprise"
                      : "Client Particulier"
                  }
                ></TextField2T>
                {quoteData.client_company ? (
                  <TextField2T
                    label={"Client"}
                    disabled={pennylane_override}
                    value={quoteData.client_name}
                    onChange={(e) =>
                      setQuoteData({
                        ...quoteData,
                        client_name: e.target.value,
                      })
                    }
                  ></TextField2T>
                ) : (
                  <>
                    <TextField2T
                      label={"Prénom"}
                      disabled={pennylane_override}
                      value={quoteData.client_first_name}
                      onChange={(e) =>
                        setQuoteData({
                          ...quoteData,
                          client_first_name: e.target.value,
                        })
                      }
                    ></TextField2T>
                    <TextField2T
                      label={"Nom"}
                      disabled={pennylane_override}
                      value={quoteData.client_last_name}
                      onChange={(e) =>
                        setQuoteData({
                          ...quoteData,
                          client_last_name: e.target.value,
                        })
                      }
                    ></TextField2T>
                  </>
                )}{" "}
                <TextField2T
                  label={"Destinataire"}
                  disabled={pennylane_override}
                  value={quoteData.client_recipient}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      client_recipient: e.target.value,
                    })
                  }
                ></TextField2T>
                <TextField2T
                  label={"Référence"}
                  disabled={pennylane_override}
                  value={quoteData.client_reference}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      client_reference: e.target.value,
                    })
                  }
                ></TextField2T>
                <TextField2T
                  label={"Email"}
                  value={quoteData.client_email}
                  disabled={pennylane_override}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      client_email: e.target.value,
                    })
                  }
                ></TextField2T>
                <TextField2T
                  label={"Téléphone"}
                  value={quoteData.client_phone}
                  disabled={pennylane_override}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      client_phone: e.target.value,
                    })
                  }
                ></TextField2T>
                <TextField2T
                  label={"Adresse"}
                  value={quoteData.client_address}
                  disabled={pennylane_override}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      client_address: e.target.value,
                    })
                  }
                ></TextField2T>
                <TextField2T
                  label={"Code Postal"}
                  value={quoteData.client_postal}
                  disabled={pennylane_override}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      client_postal: e.target.value,
                    })
                  }
                ></TextField2T>
                <TextField2T
                  label={"Ville"}
                  value={quoteData.client_city}
                  disabled={pennylane_override}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      client_city: e.target.value,
                    })
                  }
                ></TextField2T>
                <DropDownGPT03
                  disabled={pennylane_override}
                  items={payment_conditions}
                  value={quoteData.payment_conditions}
                  mandatory={true}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      payment_conditions: e.value,
                    })
                  }
                  label={"Conditions de paiement"}
                ></DropDownGPT03>
                {pennylane_override ? (
                  <div className="text-h3 text-shadow_50 mt-2 ">
                    Les informations sont récupérées depuis Pennylane, vous ne
                    pouvez pas les modifier dans cette interface
                  </div>
                ) : (
                  <div className="text-h3 text-shadow_50 mt-2 ">
                    Les modifications apportées sur le client dans cette
                    interface ne seront pas enregistrées dans hexagone
                  </div>
                )}
              </div>
              <div className="text-h3 text-shadow_50 mt-10 font-semibold">
                Informations devis
              </div>
              <div className="flex flex-col gap-1 max-w-c400 mt-3 ml-2">
                <TextField2T
                  label={"Titre"}
                  value={quoteData.devis_title}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      devis_title: e.target.value,
                    })
                  }
                ></TextField2T>
                <DatePickerGPT0
                  seconds={quoteData.devis_date?.seconds}
                  label={"Date d'émission"}
                  onChange={(e) => {
                    setQuoteData({
                      ...quoteData,
                      devis_date: getFlutterTimeFromSeconds(e),
                    });
                  }}
                ></DatePickerGPT0>
                <DatePickerGPT0
                  seconds={quoteData.devis_deadline?.seconds}
                  label={"Date d'échéance"}
                  onChange={(e) => {
                    setQuoteData({
                      ...quoteData,
                      devis_deadline: getFlutterTimeFromSeconds(e),
                    });
                  }}
                ></DatePickerGPT0>

                <DropDownGPT03
                  label={"Type de vente"}
                  items={[
                    {
                      value: "Livraison de biens",
                      label: "Livraison de biens",
                    },
                    {
                      value: "Prestation de services",
                      label: "Prestation de services",
                    },
                    {
                      value: "Livraison de biens et prestation de services",
                      label: "Livraison de biens et prestation de services",
                    },
                  ]}
                  value={quoteData.devis_type}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      devis_type: e.value,
                    })
                  }
                ></DropDownGPT03>
                <MLTFGPT1
                  label={"Description"}
                  rows={4}
                  value={quoteData.devis_description}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      devis_description: e.target.value,
                    })
                  }
                ></MLTFGPT1>
                <MLTFGPT1
                  label={"Champ libre"}
                  rows={3}
                  value={quoteData.devis_free_field}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      devis_free_field: e.target.value,
                    })
                  }
                ></MLTFGPT1>
                <MLTFGPT1
                  label={"Mention spéciale"}
                  rows={2}
                  value={quoteData.devis_special_mention}
                  onChange={(e) =>
                    setQuoteData({
                      ...quoteData,
                      devis_special_mention: e.target.value,
                    })
                  }
                ></MLTFGPT1>
              </div>{" "}
            </div>
            <div className="flex flex-col w-c600">
              <div className="text-h3 text-shadow_50 mt-10 font-semibold">
                Articles devis
              </div>
              <div className="flex flex-col gap-3  mt-3 ml-2">
                {selected_articles.map((a, index) => (
                  <div
                    key={index}
                    className="flex flex-col gap-2 border-l-2 rounded-lg border-blue-200 bg-blue-50 p-2"
                  >
                    <div className="flex flex-row gap-2">
                      <DropDownGPT03
                        mandatory={true}
                        items={articles_options.sort((a, b) =>
                          a.label.localeCompare(b.label)
                        )}
                        className={"flex-grow"}
                        label={"Sélectionnez un article"}
                        value={selected_articles[index].default}
                        onChange={(e) => {
                          let new_articles = [...selected_articles];
                          new_articles[index].default = e.value;

                          setSelectedArticles(new_articles);
                          handleSetNegocePrice(e.value, index);
                        }}
                      ></DropDownGPT03>
                      <SecondaryButton
                        onClick={() => {
                          let new_articles = [...selected_articles];
                          new_articles.splice(index, 1);
                          setSelectedArticles(new_articles);
                        }}
                        className={"w-fit"}
                      >
                        Supprimer
                      </SecondaryButton>
                    </div>
                    <div className="flex flex-row gap-3 items-center text-h3 text-shadow_50">
                      Prix
                      <CurrencyField
                        transparent={false}
                        value={selected_articles[index].price}
                        label={"Prix"}
                        disabled={false}
                        className="w-20"
                        onChangeFloat={(e) => {
                          let new_articles = [...selected_articles];
                          new_articles[index].price = e;
                          new_articles[index].total =
                            e *
                            new_articles[index].quantity *
                            (1 + new_articles[index].tax.value / 100);
                          setSelectedArticles(new_articles);
                        }}
                      ></CurrencyField>
                      Qté
                      <TextField2
                        transparent={false}
                        value={selected_articles[index].quantity}
                        label={"Quantité"}
                        className="max-w-16"
                        type="number"
                        onChange={(e) => {
                          let new_articles = [...selected_articles];
                          new_articles[index].quantity = e.target.value;
                          new_articles[index].total =
                            new_articles[index].price *
                            e.target.value *
                            (1 + new_articles[index].tax.value / 100);
                          setSelectedArticles(new_articles);
                        }}
                      ></TextField2>
                      TVA
                      <DropDownGPT0
                        items={[
                          {
                            value: 1.05,
                            pennylane_value: "FR_1.05",
                            label: "1.05%",
                          },
                          {
                            value: 1.75,
                            pennylane_value: "FR_1.75",
                            label: "1.75%",
                          },
                          {
                            value: 0.9,
                            pennylane_value: "FR_09",
                            label: "0.9%",
                          },
                          {
                            value: 2.1,
                            pennylane_value: "FR_21",
                            label: "2.1%",
                          },
                          {
                            value: 4.0,
                            pennylane_value: "FR_40",
                            label: "4.0%",
                          },
                          {
                            value: 5.5,
                            pennylane_value: "FR_55",
                            label: "5.5%",
                          },
                          {
                            value: 6.0,
                            pennylane_value: "FR_60",
                            label: "6.0%",
                          },
                          {
                            value: 6.5,
                            pennylane_value: "FR_65",
                            label: "6.5%",
                          },
                          {
                            value: 8.5,
                            pennylane_value: "FR_85",
                            label: "8.5%",
                          },
                          {
                            value: 9.2,
                            pennylane_value: "FR_92",
                            label: "9.2%",
                          },
                          {
                            value: 10.0,
                            pennylane_value: "FR_100",
                            label: "10.0%",
                          },
                          {
                            value: 13.0,
                            pennylane_value: "FR_130",
                            label: "13.0%",
                          },
                          {
                            value: 15.385,
                            pennylane_value: "FR_15.385",
                            label: "15.385%",
                          },
                          {
                            value: 19.6,
                            pennylane_value: "FR_196",
                            label: "19.6%",
                          },
                          {
                            value: 20.0,
                            pennylane_value: "FR_200",
                            label: "20.0%",
                          },
                          {
                            value: 10.0,
                            pennylane_value: "AD_10",
                            label: "10.0%",
                          },
                        ]}
                        value={selected_articles[index].tax}
                        onChange={(e) => {
                          let new_articles = [...selected_articles];
                          new_articles[index].tax = e;
                          new_articles[index].total =
                            new_articles[index].price *
                            new_articles[index].quantity *
                            (1 + e.value / 100);
                          setSelectedArticles(new_articles);
                        }}
                        label={"TVA"}
                        className={"min-w-c100"}
                      ></DropDownGPT0>
                      TOT
                      <CurrencyField
                        value={
                          Math.round(selected_articles[index].total * 100) / 100
                        }
                        label={"Total"}
                        disabled={true}
                        className="w-20"
                      ></CurrencyField>
                    </div>{" "}
                    <div className="">
                      <MLTFGPT1
                        transparent={false}
                        label={"Conditions de règlement"}
                        rows={2}
                        value={selected_articles[index].conditions_reglement}
                        onChange={(e) => {
                          let new_articles = [...selected_articles];
                          new_articles[index].conditions_reglement =
                            e.target.value;
                          setSelectedArticles(new_articles);
                        }}
                      ></MLTFGPT1>
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                      {selected_articles[index].discount ? (
                        <>
                          <SecondaryButton
                            className={"w-fit"}
                            onClick={() =>
                              // set discount to {type : "relative", value : 10}
                              {
                                let new_articles = [...selected_articles];
                                new_articles[index].discount = null;
                                setSelectedArticles(new_articles);
                              }
                            }
                          >
                            Supprimer remise
                          </SecondaryButton>
                          <DropDownGPT0X
                            items={[
                              { value: "relative", label: "%" },
                              { value: "value", label: "Valeur" },
                            ]}
                            value={selected_articles[index].discount?.type}
                            onChange={(e) => {
                              let new_articles = [...selected_articles];
                              new_articles[index].discount = {
                                type: e.value,
                                value: 10,
                              };
                              setSelectedArticles(new_articles);
                            }}
                            label={"Type de remise"}
                            className={"min-w-32"}
                          ></DropDownGPT0X>
                        </>
                      ) : (
                        <SecondaryButton
                          className={"w-fit"}
                          onClick={() =>
                            // set discount to {type : "relative", value : 10}
                            {
                              let new_articles = [...selected_articles];
                              new_articles[index].discount = {
                                type: "relative",
                                value: 10,
                              };
                              setSelectedArticles(new_articles);
                            }
                          }
                        >
                          Ajouter remise
                        </SecondaryButton>
                      )}

                      {selected_articles[index].discount?.type ===
                        "relative" && (
                        <>
                          <DropDownGPT0X
                            items={[
                              { value: 10, label: "10%" },
                              { value: 20, label: "20%" },
                              { value: 30, label: "30%" },
                              { value: 40, label: "40%" },
                              { value: 50, label: "50%" },
                            ]}
                            value={selected_articles[index].discount?.value}
                            onChange={(e) => {
                              let new_articles = [...selected_articles];
                              new_articles[index].discount = {
                                type: "relative",
                                value: e.value,
                              };
                              setSelectedArticles(new_articles);
                            }}
                            label={"Valeur de remise"}
                            className={"min-w-32"}
                          ></DropDownGPT0X>
                          <CurrencyField
                            value={
                              (selected_articles[index].discount?.value *
                                selected_articles[index].price *
                                selected_articles[index].quantity) /
                              100
                            }
                            label={"Montant de remise"}
                            disabled={true}
                            className="max-w-32"
                          ></CurrencyField>
                        </>
                      )}
                      {selected_articles[index].discount?.type === "value" && (
                        <>
                          <CurrencyField
                            transparent={false}
                            value={selected_articles[index].discount?.value}
                            onChangeFloat={(e) => {
                              let new_articles = [...selected_articles];
                              new_articles[index].discount = {
                                type: "value",
                                value: e,
                              };
                              setSelectedArticles(new_articles);
                            }}
                            label={"Montant de remise"}
                            disabled={false}
                            className="max-w-32"
                          ></CurrencyField>
                        </>
                      )}
                    </div>
                  </div>
                ))}
                <div className="flex flex-row gap-2">
                  <SecondaryButton
                    className={"w-fit"}
                    onClick={handleAddArticle}
                  >
                    Ajouter un article
                  </SecondaryButton>
                  <SecondaryButton
                    className={"w-fit"}
                    onClick={handleGoArticle}
                  >
                    Créer un article
                  </SecondaryButton>
                  {addOnOpen ? (
                    <SecondaryButton
                      className={"w-fit"}
                      onClick={() => {
                        setAddOnOpen(false);

                        setAddOnValue({ label: "", value: 0 });
                      }}
                    >
                      Retirer supplément
                    </SecondaryButton>
                  ) : (
                    <SecondaryButton
                      className={"w-fit"}
                      onClick={() => {
                        setAddOnOpen(true);

                        setAddOnValue({ label: "", value: 0 });
                      }}
                    >
                      Ajouter supplément
                    </SecondaryButton>
                  )}
                </div>

                {addOnOpen && (
                  <div className="flex flex-row gap-3 items-center text-h3 text-shadow_50 mt-10">
                    Supplément
                    <TextField2T
                      value={addOnValue.label}
                      label={"Nom du supplément"}
                      onChange={(e) => {
                        setAddOnValue({
                          label: e.target.value,
                          value: addOnValue.value || 0,
                        });
                      }}
                    ></TextField2T>
                    <CurrencyField
                      value={addOnValue.value}
                      label={"Supplément"}
                      className="w-20"
                      onChangeFloat={(e) =>
                        setAddOnValue({ label: addOnValue.label, value: e })
                      }
                      disabled={false}
                    ></CurrencyField>
                  </div>
                )}

                <div className="flex flex-col mt-10">
                  <div className="text-h1 font-semibold">Total</div>
                  <Divider orientation="horizontal" />
                  <Space y={5} />
                  <div className="flex flex-row justify-between w-full text-h3 text-shadow_50">
                    <div className="text-h3">Base HT</div>
                    <div className="text-h3">
                      {formatToEuro(getTotals().base_ht)}
                    </div>
                  </div>
                  <div className="flex flex-row justify-between w-full text-shadow_50">
                    <div className="text-h3">Supplément</div>
                    <div className="text-h3">
                      + {formatToEuro(getTotals().supplement)}
                    </div>
                  </div>
                  <div className="flex flex-row justify-between w-full text-green-600">
                    <div className="text-h3">Remises</div>
                    <div className="text-h3">
                      - {formatToEuro(getTotals().total_remise)}
                    </div>
                  </div>
                  <div className="flex flex-row justify-between w-full mt-2">
                    <div className="text-h3">Total HT</div>
                    <div className="text-h3">
                      {formatToEuro(getTotals().total_ht)}
                    </div>
                  </div>
                  <div className="flex flex-row justify-between w-full text-shadow_50 mb-2">
                    <div className="text-h3">TVA</div>
                    <div className="text-h3">
                      {formatToEuro(getTotals().tva)}
                    </div>
                  </div>{" "}
                  <Divider orientation="horizontal" />
                  <div className="flex flex-row justify-between w-full mt-1">
                    <div className="text-h3">Total TTC</div>
                    <div className="text-h3">
                      {formatToEuro(getTotals().total_ttc)}
                    </div>
                  </div>
                  <Space y={20} />
                  <div className="w-full flex flex-row-reverse mt-6">
                    <div className="w-full flex flex-row justify-end">
                      <PrimaryButton
                        disabled={loadingData}
                        onClick={handleSendDevis}
                        big={true}
                      >
                        <div className="flex flex-row gap-2 content-center align-middle items-center">
                          Générer devis pennylane{" "}
                          {loadingData && <SmallSpinner loading={true} />}
                          {!loadingData && (
                            <Icon1
                              icon_name="pennylane"
                              fill="white"
                              size={20}
                            />
                          )}
                        </div>
                      </PrimaryButton>
                    </div>
                  </div>
                </div>
              </div>

              <Space y={30} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DevisPennylane;
